import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
        currentUser:"",
	},
	actions: {
		SET_CURRENT_USER({commit,state},value){
			commit('setCurrentUser',value);
		},
		CLEAR_CURRENT_USER({commit,state}){
			commit('clearCurrentUser');
        }
	},
	mutations: {
        setCurrentUser:function(state,newValue){
			state.currentUser = newValue;
		},
        clearCurrentUser:function(state){
			state.currentUser = '';
        }
	}
});

export default store


// WEBPACK FOOTER //
// ./src/store/store.js